const menuSwedish = {
  customerSwitcher: {
    workingAs: "Arbetar som:",
    yourself: "Dig själv",
    onBehalfBanner: "Du arbetar på uppdrag av {customerName}"
  },
  menuItems: {
    dashboard: "Dashboard",
    linkedInPosts: "LinkedIn Inlägg",
    aiGenerator: "AI Generator",
    caseGenerator: "Case Generator",
    myPosts: "Mina Inlägg",
    imageArchive: "Bildarkiv",
    scheduler: "Planerare",
    aiSettings: "AI Inställningar",
    settings: "Inställningar",
    organization: "Organisation"
  },
  theme: {
    lightTheme: "Ljust tema",
    darkTheme: "Mörkt tema"
  },
  userMenu: {
    billing: "Fakturering",
    logout: "Logga ut"
  }
};

export default menuSwedish; 